import { Skeleton } from "./Skeleton";

interface ChartSkeletonProps {
  height?: number;
}

export function ChartSkeleton({ height = 260 }: ChartSkeletonProps) {
  return (
    <div className="ph-chart-skeleton" style={{ height }} aria-busy="true" aria-label="Chargement du graphique">
      <Skeleton className="ph-skeleton--chart-axis-y" />
      <div className="ph-chart-skeleton-main">
        <Skeleton className="ph-skeleton--chart-area" />
      </div>
      <div className="ph-chart-skeleton-x">
        {Array.from({ length: 7 }, (_, i) => (
          <Skeleton key={i} className="ph-skeleton--chart-tick" />
        ))}
      </div>
    </div>
  );
}
